import { IInjectable } from '@uirouter/angularjs';
import { ApiService } from '../services/api/types';

export interface TicketConfigData {
  id: string;
  ticketConfig: Record<string, string>;
}

export function TicketConfigDataResolver(): IInjectable {
  return [
    'ApiService',
    function TicketConfigData(apiService: ApiService) {
      return apiService.themes.getTicketConfig();
    },
  ];
}
